import { useCallback } from 'react'
import { DiscussionRepository } from '../../applications/ports/discussionRepository'
import api from '../../lib/commons/api'
import { Discussion } from '../../domain/entity/DiscussionEntity'

export const useDiscussionRepository = (): DiscussionRepository => {
  const createThread = useCallback(
    async (
      versionReportPageUuid: string,
      content: string,
      discussionUuid?: string,
      media?: string
    ) => {
      await api.functional.request(
        'POST',
        '/api/v1/projects/discussion/create/thread',
        {
          versionReportPageUuid,
          content,
          discussionUuid,
          media,
        }
      )
    },
    []
  )

  const createReply = useCallback(
    async (threadUuid: string, content: string, media?: string) => {
      await api.functional.request(
        'POST',
        '/api/v1/projects/discussion/reply/thread',
        {
          threadUuid,
          content,
          media,
        }
      )
    },
    []
  )

  const getDiscussion = useCallback(
    async (versionReportPageUuid: string): Promise<Discussion> => {
      const response = await api.functional.request(
        'GET',
        '/api/v1/projects/discussion/threads',
        { versionReportPageUuid }
      )
      const data = response.json

      // APIから返されるデータが期待する構造と一致しない場合のフォールバック
      return {
        discussionUuid: data.discussionUuid || '',
        discussionThreads: Array.isArray(data.discussionThreads)
          ? data.discussionThreads
          : [],
        ...data,
      }
    },
    []
  )

  return {
    createThread,
    createReply,
    getDiscussion,
  }
}
